import React, { useEffect, useState } from "react";
import ActionFormatter from "Components/Table/ActionFormatter/ActionFormatter";
import AlertDialog from "Components/AlertDialog/AlertDialog";
import { read } from "Helpers/LocalStorage";
import { useDispatch, useSelector } from "react-redux";
import Translator from "Languages/Utility/Translator";
import { deleteShishe } from "Stores/actions";
import { SAVE_ALL_SHISHE } from "Stores/actionTypes";
import * as Icons from 'react-bootstrap-icons';

function DeleteShishe({ row }) {
  const { dataRelationShishe, shishe, shishePagination } = useSelector(
    (state) => ({
      dataRelationShishe: state.shishe.dataRelationShishe,
      shishe: state.shishe.shishe,
      shishePagination: state.shishe.shishePagination,
    })
  );
  const [showAlert, setShowAlert] = useState(false);
  const [deleteRelationData, setDeleteRelationData] = useState(null);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const onShowAlert = () => {
    setShowAlert(!showAlert);
    setDeleteRelationData(null);
  };

  const onDelete = async () => {
    try {
      setLoading(true);
      const data = {
        KeyGroup: read("groupKey"),
        KeyUser: read("userKey"),
        Id: row.Id,
      };
      const res = await dispatch(deleteShishe(data));
      if (res) {
        onShowAlert();
        dispatch({
          type: SAVE_ALL_SHISHE,
          shishe: shishe.filter((item) => item.Id !== row.Id),
          shishePagination: shishePagination,
        });
      }
      setLoading(false);
    } catch (err) {
      console.error('[catch error]', err)
    }
  };

  useEffect(() => {
    setDeleteRelationData(dataRelationShishe);
  }, [dataRelationShishe]);

  return (
    <>
      <ActionFormatter
        title={<Translator id="hazf" />}
        icon={<Icons.Trash3 size={17} />}
        className="danger-fill"
        onClick={onShowAlert}
        disabled={
          (row.IsG && read("StypeU") !== "1") ||
          row.Disable ||
          read("ShisheRules").accessDelete === false
        }
      />
      <AlertDialog
        showAlert={showAlert}
        type="alertError"
        onClose={onShowAlert}
        onClickOk={onDelete}
        okTitle={<Translator id="ble_pak_shavad" />}
        cancelTitle={<Translator id="enseraf" />}
        questionText={<Translator id="aya_az_hazf_an_etminan_darid" />}
        relationText={<Translator id='relationAlert' />}
        relationData={deleteRelationData}
        loading={loading}
      />
    </>
  );
}

export default DeleteShishe;
